export default __webpack_public_path__ + "static/media/icon-save.e2e0b010.svg";